import styles from "./HomeProcessSteps.module.scss";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate } from "react-router-dom";

const STEPS = [
  {
    icon: <TravelExploreIcon />,
    title: "Explore",
    description:
      "Browse academic resources from research institutions worldwide.",
  },
  {
    icon: <CompareArrowsIcon />,
    title: "Compare",
    description: "Make a wishlist of your favorites and compare profiles.",
  },
  {
    icon: <FactCheckIcon />,
    title: "Decide",
    description: "Pick the ones that fit your research interests best.",
  },
  {
    icon: <SendIcon />,
    title: "Connect",
    description: "Reach out and start collaborating with researchers.",
  },
];

const FEATURES = [
  {
    id: "faculty",
    title: "Faculty",
    description:
      "Discover academic professionals, their research interests, publications, and expertise across various disciplines.",
    image: `${process.env.PUBLIC_URL}/features/faculty.png`,
    path: "/explore/faculties"
  },
  {
    id: "institution",
    title: "Institution",
    description:
      "Explore research institutions worldwide and their contributions to academic knowledge.",
    image: `${process.env.PUBLIC_URL}/features/institution.png`,
    path: "/explore/institutions"
  },
  {
    id: "unit",
    title: "Unit",
    description:
      "Browse research units and departments specializing in specific fields of study.",
    image: `${process.env.PUBLIC_URL}/features/unit.png`,
    path: "/explore/units"
  },
  {
    id: "venue",
    title: "Venue",
    description:
      "Find academic journals, conferences, and publication venues for your research.",
    image: `${process.env.PUBLIC_URL}/features/venue.png`,
    path: "/explore/venues"
  },
];

const HomeProcessSteps = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className={styles["home-process-steps"]}>
        {/* Process Steps */}
        <div className={styles["home-process-steps__container"]}>
          {STEPS.map((step, index) => (
            <div key={index} className={styles["home-process-steps__item"]}>
              <div className={styles["home-process-steps__icon-wrapper"]}>
                <div className={styles["home-process-steps__icon"]}>
                  {step.icon}
                </div>
                {index < STEPS.length - 1 && (
                  <div className={styles["home-process-steps__connector"]} />
                )}
              </div>
              <h3 className={styles["home-process-steps__title"]}>
                {step.title}
              </h3>
              <p className={styles["home-process-steps__description"]}>
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* Discover Our Features */}
      <div className={styles["home-process-steps__features"]}>
        <h2 className={styles["home-process-steps__features-title"]}>
          Discover Our Features
        </h2>
        <div className={styles["home-process-steps__features-grid"]}>
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className={styles["home-process-steps__feature-card"]}
              style={{ backgroundImage: `url(${feature.image})` }}
              onClick={() => navigate(feature.path)}
            >
              <div className={styles["home-process-steps__feature-overlay"]}>
                <h3 className={styles["home-process-steps__feature-title"]}>
                  {feature.title}
                </h3>
                <p
                  className={styles["home-process-steps__feature-description"]}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeProcessSteps;
